module.exports = __webpack_public_path__ + "img/uponline-multibeneficii.3a399896.png";